$(document).on('turbo:load turbo:render', () => {
    let roleSelectionContainer = $('.card-row-container');
    if (roleSelectionContainer.length) {
        let checkboxes = roleSelectionContainer.find(".choose-role.checkbox input");
        checkboxes.each((i, box) => {
            if ($(box).prop('checked')) {
                $(box).closest('label').addClass('checked');
            }
        });
    }
});